import type { FileItem } from "../../types";
import type { ColumnDef } from "@tanstack/react-table";
import { SelectableTableContent } from "../category-views/shared/SelectableTableContent";
import { useRemoteTable } from "../category-views/shared/useRemoteTable";

interface FileGalleryTableProps {
  files: FileItem[];
  columns: ColumnDef<FileItem>[];
  selectedFile: FileItem | null;
  selectedFileIds?: Set<string>;
  onFileSelect: (file: FileItem) => void;
}

export function FileGalleryTable({
  files,
  columns,
  selectedFile,
  selectedFileIds,
  onFileSelect,
}: FileGalleryTableProps) {
  const table = useRemoteTable<FileItem>({
    data: files,
    columns,
  });

  return (
    <SelectableTableContent
      table={table}
      getRowId={(file) => file.id}
      selectedId={selectedFile?.id}
      selectedIds={selectedFileIds}
      onRowSelect={onFileSelect}
    />
  );
}
